import { AnyAction } from "redux";
import {
  REQUEST_FETCH_SCHEDULE_CITIES,
  REQUEST_FETCH_SCHEDULE_CITIES_ERROR,
  REQUEST_FETCH_SCHEDULE_CITIES_SUCCESS,
} from "redux/actions/general/cities";

const defaultState = {
  data: [],
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_SCHEDULE_CITIES:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_FETCH_SCHEDULE_CITIES_SUCCESS:
      return {
        data: action.cities,
        error: null,
        loading: false,
      };
    case REQUEST_FETCH_SCHEDULE_CITIES_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
